import { Loading } from '@app/components/common/Loading';
import { useAddAccountingEntriesPermission } from '@app/modules/mje/hooks/useUserProfilePermission';
import { Navigate } from 'react-router-dom';

export const PermissionAddAccountingEntriesOutlet = ({ children }: any) => {
  const { addAccountingEntries, isLoading } =
    useAddAccountingEntriesPermission();

  if (isLoading || addAccountingEntries === null) return <Loading />;

  return addAccountingEntries ? (
    children
  ) : (
    <Navigate to="/server-error?c=403" replace />
  );
};
